import { Analytics } from './analytics';

let storeButton = $('[store-item-button]');

storeButton.click((e) => {
    let nameItem = $(e.target).closest('.store-item-button-wrapper').siblings('.store-item-infos').find('.store-item-title').text();
    
    Analytics.sendEvent('Publication Pages - Buy Online Clicks', nameItem, window.location.pathname)
});